import _ from 'lodash';
import {EMPTY_SORT_OBJECT, SortForStore} from 'utils/sort';
import {ActionObject} from 'ducks/types';

export const SORTING = {
  BOOKING_LIST: 'bookingList',
  INVOICE_REPORTING_LIST: 'invoiceReportingList',
  ARRIVALS_TABLE: 'arrivalsTable',
  DEPARTURES_TABLE: 'departuresTable',
  ROOM_MOVES_AND_STAYOVERS_TABLE: 'roomMovesAndStayoversTable',
  PAYMENTS_LIST: 'paymentsList',
  BOOKING_SET_LIST: 'bookingSets',
  CREDIT_NOTES_LIST: 'creditNotesList',
  AVAILABILITY_TABLE: 'availabilityTable'
};

export const selectSort = (state, namespace: string): SortForStore => {
  return _.get(state, `sorting.${namespace}`, EMPTY_SORT_OBJECT);
};

type SetSortType = (
  data: {namespace: string; sortForStore: SortForStore}
) => ActionObject;

const SET_SORT = 'sorting/SET_SORT';
export const setSort: SetSortType = ({namespace, sortForStore}) => ({
  type: SET_SORT,
  payload: {
    namespace,
    sortForStore
  }
});

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SORT:
      return {
        ...state,
        [action.payload.namespace]: action.payload.sortForStore
      };
    default:
      return state;
  }
};

export default reducer;
